import {
  AcceptInvitationResult,
  BusinessRole,
  InvitationPreview,
} from '../types';
import { USE_MOCK_INVITATION } from '../constants/buyer-portal';
import { invitationMock } from '../mocks/invitationMock';
import { clinicHttp, getClinicToken, getRefreshToken } from './http';
import { ENDPOINTS } from './endpoints';
import {
  BusinessDtoBackend,
  InvitationPreviewDtoBackend,
  mapInvitationPreviewDto,
} from './businessMapper';

export type InvitationService = {
  preview: (token: string) => Promise<InvitationPreview>;
  accept: (token: string) => Promise<AcceptInvitationResult>;
};

const realInvitationService: InvitationService = {
  preview: async (token) => {
    const res = await clinicHttp.get<InvitationPreviewDtoBackend>(
      ENDPOINTS.AUTH.INVITATION_PREVIEW(token),
    );
    return mapInvitationPreviewDto(res.data, token);
  },
  accept: async (token) => {
    // Backend returns BusinessDto and doesn't rotate the JWT — `currentBusiness`
    // is resolved server-side on the next /auth/me. The store calls refreshMe()
    // after this returns.
    const res = await clinicHttp.post<BusinessDtoBackend>(
      ENDPOINTS.AUTH.INVITATION_ACCEPT(token),
    );
    const business = res.data;
    return {
      businessId: business.id,
      businessName: business.name ?? '',
      role: 'MEMBER' as BusinessRole,
      status: 'ACCEPTED',
      newToken: {
        accessToken: getClinicToken() ?? '',
        refreshToken: getRefreshToken() ?? '',
        expiresIn: 0,
      },
    };
  },
};

export const invitationService: InvitationService = USE_MOCK_INVITATION
  ? invitationMock
  : realInvitationService;
